export default __webpack_public_path__ + "static/media/Priest's Threads of Sacrifice.1dc522a1.jpg";